import { requestedEmbryoSpecimensFixture } from "@src/packages/cycles/test-fixtures/embryoReportFixture";
import { useSpecimens, type Specimen } from "../useSpecimens";

const NO_SPECIMENS: Specimen[] = [];

/**
 * The patient's embryo records in the cryo vault, across every cycle. The
 * Embryo testing page reads each tested embryo's status from the record its
 * report links to, finds the cycle's untested embryos, and counts the frozen
 * euploid embryos banked from other batches.
 *
 * The error is returned, not dropped: without the vault those parts of the
 * page vanish, and the page has to say so.
 */
export function useEmbryoSpecimens() {
  const fixture = requestedEmbryoSpecimensFixture();
  const { data, error, refetch, isFetching } = useSpecimens("embryo", {
    enabled: fixture === null,
  });
  return {
    specimens: fixture ?? data ?? NO_SPECIMENS,
    error: fixture ? null : error,
    refetch,
    isFetching,
  };
}
